import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import validateStep3 from './validateStep3';

import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import stepDiscountIllustration from '/public/SiteImages/step-discount.svg';

import { normalizePrice } from '../../helpers/normalizePrice';
import updateStep3 from './updateStep3';

import calendarIcon from '/public/SiteIcons/calendar3.svg';
import calendarMesIcon from '/public/SiteIcons/calendario-mes.svg';


import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';

class Discount extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
    };
  }

  UNSAFE_componentWillMount() {
    const { valid, listingFields } = this.props;

    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid, listingFields } = nextProps;

    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  renderPercentInput = ({ input, placeholder, meta: { touched, error } }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div style={{ flex: 1 }}>
        <input
          {...input}
          type="text"
          placeholder={placeholder}
          className={s.pricingInputField}
        />
        {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      </div>
    );
  };

  render() {
    const { handleSubmit, nextPage, previousPage, formPage, step } = this.props;
    const { isDisabled } = this.state;
    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title={`¿Quieres ofrecer un \n`}
            highlightText={`descuento por \n reservar más noches?`}
            subtitle=""
            iconImg={stepDiscountIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={cx(s.stepRightCard, s.pricingStepCard)}>
              <div className={s.landingMainContent}>
                <br />
                <p className={s.amenitiesSpacesLabel}>Esto puede ayudar a incentiva a huéspedes a elegir tu {`\n`} espacio cuando necesitan estadías más largas.</p>

                <hr className={s.pricingDivider} />

                {/* Descuento semanal */}
                <div className={s.pricingSectionBlock}>
                  <div className={s.pricingSectionHeader}>
                    <div className={s.pricingSectionIcon}>
                      <img src={calendarIcon} className={s.pricingSectionIconImg} alt="" />
                    </div>
                    <div className={s.pricingSectionText}>
                      <h2 className={s.pricingSectionTitle}>Descuento semanal</h2>
                      <div className={s.pricingInputBox}>
                        <span className={s.pricingCurrencyLabel}>%</span>
                        <Field
                          name="weeklyDiscount"
                          type="text"
                          component={this.renderPercentInput}
                          normalize={normalizePrice}
                          placeholder="0"
                        />
                      </div>
                      <p className={s.discountSectionSubtitle}>Descuento para huéspedes que reserven por más de una semana.</p>
                    </div>
                  </div>


                </div>

                <hr className={s.pricingDivider} />

                {/* Descuento mensual */}
                <div className={s.pricingSectionBlock}>
                  <div className={s.pricingSectionHeader}>
                    <div className={s.pricingSectionIcon}>
                      <img src={calendarMesIcon} className={s.pricingSectionIconImg} alt="" />
                    </div>
                    <div className={s.pricingSectionText}>
                      <h2 className={s.pricingSectionTitle}>Descuento mensual</h2>
                      <div className={s.pricingInputBox}>
                        <span className={s.pricingCurrencyLabel}>%</span>
                        <Field
                          name="monthlyDiscount"
                          type="text"
                          component={this.renderPercentInput}
                          normalize={normalizePrice}
                          placeholder="0"
                        />
                      </div>
                      <p className={s.discountSectionSubtitle}>Descuento para huéspedes que reserven por más de un mes.</p>
                    </div>
                  </div>
                </div>
              </div>
              <FooterButton
                nextPage={nextPage}
                previousPage={previousPage}
                nextPagePath={"advance-notice"}
                previousPagePath={"pricing"}
                formPage={formPage}
                step={step}
                isDisabled={isDisabled}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

Discount = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(Discount);

const mapState = (state) => ({
  listingFields: state.listingFields.data
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Discount)));
